import { render, staticRenderFns } from "./GeneralJournalSummaryEntries.vue?vue&type=template&id=187d64a4&scoped=true"
import script from "./GeneralJournalSummaryEntries.vue?vue&type=script&lang=js"
export * from "./GeneralJournalSummaryEntries.vue?vue&type=script&lang=js"
import style0 from "./GeneralJournalSummaryEntries.vue?vue&type=style&index=0&id=187d64a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187d64a4",
  null
  
)

export default component.exports